module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioFinalExamenAdminProyectos.abcdf74b.pdf";